module.exports = __webpack_public_path__ + "img/area_7.84ea072c.png";